module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "body_Praise--Heading3-"
  }, [_vm._v("Praise for "), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("The Best New True Crime Stories: "), _c('br'), _vm._v("Unsolved Crimes & Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Haunting and heartbreaking, "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Unsolved Crimes & Mysteries ")]), _vm._v("lives up to its title, and is a must-read for true crime aficionados. It’s an ambitious collection of unsolved mysteries, spanning the globe and time—from France in the Roaring Twenties to Los Angeles in the 1960s to the Appalachian Trail in the 1990s, and beyond. The authors skillfully shed new light on long-forgotten murders, chronical a baffling and brazen art heist, and lay bare the systemic and societal failures in each case. But most of all, the authors honor the victims. Because maybe, just maybe, these renewed accounts will spawn new clues that will provide answers to grieving families, and perhaps even justice. I can’t stop thinking about these stories, and I highly"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("r"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ecommend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Alex Finlay")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Every Last Fear")]), _vm._v(" and "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("The N")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("ight")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Shift")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Ever since reading Megan Abbott’s "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The Song is You, ")]), _vm._v("I can’t get enough of Jean Spangler, so I was thrilled to see the bizarre 1949 disappearance of the Hollywood bit actress turn up in Mitzi Szereto’s latest collection of unsolved true crimes. If you love history and mystery, you’ll love t"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("David Bushman")]), _vm._v(", author of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Murder at Teal’s Pond: Hazel Drew and the Mystery That Inspired ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Twin")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Peaks")])])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“An unusually moving read. I was struck by the compassion and sensitivity with which the murders were described, as each of the authors felt a personal sympathy with and even a connection to "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("the")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("case.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Linda Stratmann")]), _vm._v(", author of thirty true crime and crime fiction books, including her new series featuring a young Sherl"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ock")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Holmes")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Quality literature always leaps from the pages when professional true crime writers dip quills into ink. This book is no exception. A great compilation of gut-wrenching cases giving ‘reader involvement and participation:’ the authors ‘talk to the reader’ not ‘"), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("at")]), _vm._v(" the reader,’ which is a style I encourage and thoroughly endorse. Well laid out. Dedicated research. This is a must-read book for all those interested in tr"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ue")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("crime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Christopher Berry-Dee")]), _vm._v(", criminologist; christopherbe"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("rrydee.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Quote"
  }, [_vm._v("“Author and editor extraordinaire Mitzi Szereto has assembled an outstanding group of leading authors from throughout the world for this incredible collection—"), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("The Best New True Crime Stories: Unsolved Crimes & Mysteries")]), _vm._v(". A truly fantastic"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("a"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("nthology!”")])]), _vm._v(" "), _c('p', {
    staticClass: "body_QuoteAuthor"
  }, [_vm._v("—"), _c('span', {
    staticClass: "Bold _idGenCharOverride-3"
  }, [_vm._v("Dan Zupansky")]), _vm._v(", author and host of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("rue")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-4"
  }, [_vm._v("Murder")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e83acf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories.vue
// module id = 57
// module chunks = 0